import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import { useStyles } from './styles.js';

const InputHelperText = ({ helperText }) => {
    const styles = useStyles();

    return <Typography className={styles.helperText}>{helperText}</Typography>;
};

InputHelperText.propTypes = {
    helperText: PropTypes.string,
};

export default InputHelperText;
